import { useEffect, useRef, useState } from "react";
import { approveRequest, getRequestDetailsByUserId } from "../../services/AllServices";
import { getValueByKeyIfExist, showMessage } from "../../utils/helpers";
import { useNavigate, useParams } from "react-router-dom";
import localStorageService from "../../services/LocalStorageService";

const useRequestManagementViewViewController = () => {

    const [showPopup, setShowPopup] = useState(false);
    const { id } = useParams();
    const [status, setStatus] = useState("");
    const [requestDetails, setRequestDetails] = useState({});
    const userId = localStorageService.getItem("user_id") || "";
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const renderAfterCalled = useRef(false);
    const transferSid = getValueByKeyIfExist(
      requestDetails?.request_items,
      "transfer_sid"
    );
    useEffect(() => {
      const fetchRequestDetails = async () => {
        setLoading(true);
        try {
          const response = await getRequestDetailsByUserId(userId, id);
          setRequestDetails(response?.data);
        } catch (error) {
          showMessage("error", error?.response?.data?.message || "Something went wrong");
        }
        setLoading(false);
      };
  
      if (!renderAfterCalled.current) {
        fetchRequestDetails();
      }
      renderAfterCalled.current = true;
    }, [id, userId]);

    const handleShowPopup = (e, requestStatus) => {
      e?.preventDefault();
      setStatus(requestStatus);
      setShowPopup(true);
    };
  
    const handleClosePopup = () => {
      setShowPopup(false);
    };
  
    const handleSubmit = async (comment) => {
      setShowPopup(false);
      setLoading(true);
      try {
        const sendBody = {
          comments: comment,
          approval_status: status,
        };
        const response = await approveRequest(userId, id, sendBody);
        showMessage("success", `Request ${status} successfully`);
        navigate(-1);
      } catch (error) {
        setShowPopup(false);
        showMessage("error", error?.response?.data?.message || "Something went wrong");
      }
      setLoading(false);
    };
  
    const goBack = () => {
      navigate('/request-management');
    }

    return {
        goBack,
        showPopup,
        handleShowPopup,
        handleClosePopup,
        handleSubmit,
        requestDetails,
        transferSid,
        loading
    };
};

export default useRequestManagementViewViewController;